import axiosApiClient from '..';
import { handleError } from '../../utils/errors';

const BASE_URL = '/toDo';

class ToDoService {
  getClientToDos = async ({ id, page }) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/client/${id}?page=${page}`);
      if (response.status !== 200) {
        throw new Error();
      }

      const { data, message, maxReached, total } = response.data;

      return { data, message, maxReached, total };
    } catch (err) {
      throw handleError(err, "Error occurred while fetching client to do's by id.");
    }
  };

  createToDoForClient = async (id, body) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/client/${id}`, body);
      if (response.status !== 201) {
        throw new Error();
      }

      const { data } = response.data;

      return { data };
    } catch (err) {
      throw handleError(err, 'Error occurred while creating to do for client.');
    }
  };

  deleteToDoForClient = async id => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }

      const { data } = response.data;

      return { data, id };
    } catch (err) {
      throw handleError(err, 'Error occurred while deleting to do for client.');
    }
  };

  createTemplateToDo = async body => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/vendor/toDoTemplate`, body);
      if (response.status !== 201) {
        throw new Error();
      }
      const { data } = response.data;
      return { data };
    } catch (err) {
      throw handleError(err, 'Error occurred while creating to do template.');
    }
  };

  editTemplateToDo = async (id, body) => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/vendor/toDoTemplate/${id}`, body);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;
      return { data };
    } catch (err) {
      throw handleError(err, 'Error occurred while editing to do template.');
    }
  };

  getToDoTemplates = async page => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/vendor/toDoTemplate?page=${page}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data, maxReached, total, perPage } = response.data;
      return { data, maxReached, total, page, perPage };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching to do templates.');
    }
  };

  getToDoTemplateById = async id => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/vendor/toDoTemplate/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data, message } = response.data;
      return { data, message };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching to do template by id.');
    }
  };

  createTemplateToDoForClient = async (id, templates) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/client/${id}/toDoTemplate`, { templates });
      if (response.status !== 201) {
        throw new Error();
      }
      const { data } = response.data;
      return { data };
    } catch (err) {
      throw handleError(err, 'Error occurred while creating to do template for client.');
    }
  };

  editClientToDo = async (id, body) => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/client/${id}`, body);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;
      return { data, id };
    } catch (err) {
      throw handleError(err, 'Error occurred while changing date for client toDo.');
    }
  };

  deleteToDoTemplate = async id => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/template/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;
      return { data, id };
    } catch (err) {
      throw handleError(err, 'Error occurred while deleting to do template.');
    }
  };
}
const toDoService = new ToDoService();

export default toDoService;
